import React from 'react'
import './Banner.css'

const Banner = () => {
    return (
        <div className='banner-img'>
<div className='banner'>
</div>
</div>
    )
}

export default Banner
